<template>
  <a-modal :title="title" :width="width" :visible="visible" :confirmLoading="confirmLoading" @ok="handleOk" @cancel="handleCancel" cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item label="基地" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['baseId', validatorRules.baseId]" :trigger-change="true" dictCode="bus_inspection_base,base,id"
            placeholder="请选择基地" />
        </a-form-item>
        <a-form-item label="配置名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'configName', validatorRules.configName]" placeholder="请输入配置名称"></a-input>
        </a-form-item>
        <a-form-item label="配置类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['configType', validatorRules.configType]" :trigger-change="true" dictCode="standard_team_task_type"
            placeholder="请选择配置类型" />
        </a-form-item>
        <a-form-item label="任务生成类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['createTaskType', validatorRules.createTaskType]" :trigger-change="true" dictCode="standard_team_config_day_type"
            placeholder="请选择配置类型" />
        </a-form-item>
        <a-form-item label="配置备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'configRemark', validatorRules.configRemark]" placeholder="请输入配置备注"></a-input>
        </a-form-item>
        <a-form-item label="开始时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-time-picker format="HH:mm" v-decorator="[ 'startTime',validatorRules.startTime]" />
        </a-form-item>
        <a-form-item label="结束时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-time-picker format="HH:mm" v-decorator="[ 'endTime',validatorRules.endTime]" />
        </a-form-item>
        <a-form-item label="计划次数" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="[ 'planNum', validatorRules.planNum]" placeholder="请输入计划次数" style="width: 100%" />
        </a-form-item>
        <a-form-item label="分数设置" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="[ 'score', validatorRules.score]" placeholder="请输入分数设置" style="width: 100%" />
        </a-form-item>
        <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="radio" v-decorator="['delFlag', validatorRules.delFlag]" :trigger-change="true" dictCode="del_flag" placeholder="请选择状态"/>
        </a-form-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

import { httpAction } from '@/api/manage'
import pick from 'lodash.pick'
import moment from 'moment';
import { validateDuplicateValue } from '@/utils/util'
import JDictSelectTag from "@/components/dict/JDictSelectTag"

export default {
  name: "BusStandardTeamConfigModal",
  components: {
    JDictSelectTag,
  },
  data() {
    return {
      form: this.$form.createForm(this),
      title: "操作",
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {
        baseId: {rules: [
          {required: true, message: '请选择基地!'},
        ]},
        configName: {rules: [
          {required: true, message: '请输入配置名称!'},
        ]},
        configType: {rules: [
          {required: true, message: '请输入配置类型!'},
        ]},
        createTaskType: {rules: [
          {required: true, message: '请输入任务生成类型!'},
        ]},
        startTime:{
          initialValue:moment("00:00","HH:mm"),
        },
        endTime:{
          initialValue:moment("23:59","HH:mm"),
        },
        planNum: {rules: [
          {required: true, message: '请输入计划次数!'},
        ]},
        score: {rules: [
          {required: true, message: '请输入分数设置!'},
        ]},
        delFlag: {rules: [
          {required: true, message: '请选择是否开启!'},
        ]},
      },
      url: {
        add: "/standardTeam/config/add",
        edit: "/standardTeam/config/edit",
      }
    }
  },
  created() {
  },
  methods: {
    add(record) {
      record.delFlag="0"
      record.planNum="1"
      this.edit(record);
    },
    edit(record) {
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(() => {
        let data = pick(this.model, 'baseId_dictText', 'configRemark', 'configType', 'startTime', 'endTime', 'delFlag', 'baseId', 'configName', 'createTaskType', 'planNum', 'score')
        data.startTime=moment(data.startTime?data.startTime:"00:00", 'HH:mm')
        data.endTime=moment(data.endTime?data.endTime:"23:59", 'HH:mm')
        this.form.setFieldsValue(data);
      })
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, fieldsValue) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if (!this.model.id) {
            httpurl += this.url.add;
            method = 'post';
          } else {
            httpurl += this.url.edit;
            method = 'post';
          }
          const values={
              ...fieldsValue,
              startTime:fieldsValue.startTime.format('HH:mm'),
              endTime:fieldsValue.endTime.format('HH:mm'),
            }
          let formData = Object.assign(this.model, values);
          console.log("表单提交数据", formData)
          httpAction(httpurl, formData, method).then((res) => {
            if (res.success) {
              that.$message.success(res.message);
              that.$emit('ok');
            } else {
              that.$message.warning(res.message);
            }
          }).finally(() => {
            that.confirmLoading = false;
            that.close();
          })
        }

      })
    },
    handleCancel() {
      this.close()
    },
    popupCallback(row) {
      console.log('popupCallback-row',row)
      console.log('popupCallback-this.form',this.form)
      this.form.setFieldsValue(pick(row, 'baseId_dictText', 'configRemark', 'configType', 'startTime', 'endTime', 'delFlag', 'baseId', 'configName', 'createTaskType', 'planNum', 'score'))
      // this.form.startTime=moment(this.form.startTime?this.form.startTime:"00:00", 'HH:mm')
      // this.form.endTime=moment(this.form.endTime?this.form.endTime:"23:59", 'HH:mm')
    },


  }
}
</script>